import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react/enhancers';
import { compose } from '@beef/utils';
import { selectFTTBAccumulators } from "../store";
import { HomeServices } from "../../HomeServices";
var _FTTBAccumulators = function _FTTBAccumulators(_ref) {
  var accumulators = _ref.accumulators;
  return /*#__PURE__*/React.createElement(HomeServices, {
    items: accumulators,
    "data-t-id": "FTTBTariff-FTTBAccumulators"
  });
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    accumulators: selectFTTBAccumulators(state),
    shouldRender: !!selectFTTBAccumulators(state)
  };
};
export var FTTBAccumulators = compose(connect(mapStateToProps), withRenderFlag)(_FTTBAccumulators);